<template>
  <my-dialog
ref="editForm" :visible.sync="showDialog" :title="title" dialog-type="form" :close-on-click-modal="false"
    width="80%" @close="closeDialog">
    <div v-loading="loading" class="main_bg" element-loading-text="加载中...">
      <div class="item_info border_Warningcolor">
        <el-descriptions class="margin-top" title="基本信息" :column="4" border>
          <template #extra>
            <el-button type="primary" size="small" icon="el-icon-plus" @click="GenerateInputNumber">获取入库单号</el-button>
          </template>
          <el-descriptions-item label="入库单号"><el-input v-model="editForm.inputStoreNo" style="width: 100%" placeholder="请生成入库单号" disabled /></el-descriptions-item>
          <el-descriptions-item label="供应商">
            <el-select
v-model="supplyInfo.keyId" placeholder="请选择供应商" clearable style="width: 100%"
              @change="handleSelectSupply">
              <el-option
v-for="item in supplyList" :key="item.keyId" :label="item.name"
                :value="item.keyId"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="供应商联系人"><el-input v-model="supplyInfo.contactUser" style="width: 100%" placeholder="请选择供应商" disabled /></el-descriptions-item>
          <el-descriptions-item label="供应商电话"><el-input v-model="supplyInfo.contactPhone" style="width: 100%" placeholder="请选择供应商" disabled /></el-descriptions-item>
          <el-descriptions-item span="2" label="供应商地址"><el-input v-model="supplyInfo.address" style="width: 100%" placeholder="请选择供应商" disabled /></el-descriptions-item>
          <el-descriptions-item span="2" label="商品信息">
            <el-cascader
v-model="editForm.typeKeyId" :options="goodsTypeList" :props="cascaderProps"
              placeholder="请选择商品信息" clearable filterable style="width: 100%;" @change="handleTypeChange"></el-cascader>
          </el-descriptions-item>
          <el-descriptions-item span="3" label="备注"><el-input clearable v-model="editForm.remark" style="width: 100%" placeholder="请输入备注" /></el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="item_info border_Green">
        <div class="item_title">
          <div class="title">商品信息</div>
        </div>
        <div class="tableData">
          <table class="highlight-table">
            <thead>
              <tr>
                <th class="fixed-column" style="width: 60px;">球镜\柱镜</th>
                <th v-for="(item, colIndex) in zhuJingList" :key="colIndex">
                  {{ item.paramsValue }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(itemTr, rowIndex) in qiuJingList" :key="rowIndex">
                <td class="qiuJing fixed-column">
                  {{ itemTr.paramsValue }}
                </td>
                <td v-for="(item, colIndex) in zhuJingList" :key="colIndex">
                  <input
v-model.number="goodsStockQtyList[rowIndex][colIndex]" type="number" :min="0" :step="1" onmousewheel="return false"
                    class="inputQuantity"></input>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <template #footer>
<div class="dialog-footer">
      <el-button size="small" @click="closeDialog">取消</el-button>
      <el-button size="small" type="primary" :loading="saveloading" class="title" @click="submitForm()">
        保存
      </el-button>
    </div>
</template>
  </my-dialog>
</template>
<script>
import {
  GetInputStoreDeatail,
  GenerateInputNumber,
  SaveInputStore
} from "@/api/receiptApi.js";
import {
  getSupplyInfoList,
  GetGoodsParamsList,
  GetAllGoodsTypeTreePageList
} from "@/api/baseDataApi.js";

export default {
  props: [],
  data() {
    return {
      title: "新增入库单",
      showDialog: false,
      saveloading: false,
      loading: false,
      editForm: {
        keyId: "",
        inputStoreNo: "",
        remark: "",
        typeKeyId: ""
      },
      isEdit: false,
      supplyList: [],
      supplyInfo: {
        keyId: "",
        name: "",
        contactUser: "",
        contactPhone: "",
        address: ""
      },
      goodsTypeList: [],
      goodsStockQtyList: [],
      qiuJingList: [],
      zhuJingList: [],
      cascaderProps: {
        value: "keyId", // 绑定值的属性名
        label: "name", // 显示文本的属性名
        children: "subList", // 子节点的属性名
        checkStrictly: false, // 可以选择任意一级
        expandTrigger: "click" // 展开方式
      }
    };
  },
  computed: {},
  watch: {},
  components: {},
  created() { },
  methods: {
    // 显示
    showCreateDialog(keyId, isEdit = false) {
      this.editForm.keyId = keyId;
      this.isEdit = isEdit;
      this.showDialog = true;
      if (isEdit) {
        this.title = "编辑入库单";
      } else {
        this.title = "新增入库单";
      }
      this.editForm.supplyKeyId = "";
      this.supplyInfo = {};
      this.getSupplyInfoList();
      this.GetGoodsParamsList();
      this.GetAllGoodsTypeTreePageList();
    },
    // 点击保存
    submitForm() {
      let params = {
        supplyKeyId: this.supplyInfo.keyId,
        inputStoreNo: this.editForm.inputStoreNo,
        remark: this.editForm.remark,
        typeKeyId: this.editForm.typeKeyId
      };
      if (
        params.supplyKeyId === "" ||
        params.supplyKeyId === null ||
        params.supplyKeyId === undefined
      ) {
        this.$message({
          type: "error",
          message: "请选择供应商！"
        });
        return;
      }
      if (
        params.inputStoreNo === "" ||
        params.inputStoreNo === null ||
        params.inputStoreNo === undefined
      ) {
        this.$message({
          type: "error",
          message: "请获取入库单号！"
        });
        return;
      }
      if (
        params.typeKeyId === "" ||
        params.typeKeyId === null ||
        params.typeKeyId === undefined
      ) {
        this.$message({
          type: "error",
          message: "请选择商品信息！"
        });
        return;
      }
      let stockGoods = [];
      for (let i = 0; i < this.goodsStockQtyList.length; i++) {
        let item = this.goodsStockQtyList[i];
        for (let j = 0; j < item.length; j++) {
          if (item[j] > 0) {
            let stockGoodsItem = {
              quantity: item[j],
              paramsKeyId1: this.qiuJingList[i].keyId,
              paramsKeyId2: this.zhuJingList[j].keyId
            };
            stockGoods.push(stockGoodsItem);
          }
        }
      }
      if (stockGoods.length === 0) {
        this.$message({
          type: "error",
          message: "请输入要入库的数量！"
        });
        return;
      }
      params.dtls = stockGoods;

      SaveInputStore(params).then((res) => {
        if (res.code == 1) {
          this.$message({
            type: "success",
            message: "入库单创建成功！"
          });
          this.closeDialog();
          this.$parent.search();
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    // 获取入库单详情
    GetInputStoreDeatail() {
      // 清空上一次的数据，显示加载中
      this.resetData();
      this.loading = true;
      this.saveloading = true;
      const params = {
        keyId: this.editForm.keyId
      };
      GetInputStoreDeatail(params)
        .then((res) => {
          this.saveloading = false;
          if (res.code == 1) {
            this.editForm.inputStoreNo = res.data.inputStoreNo;
            this.editForm.supplyKeyId = res.data.supplyKeyId;
            this.editForm.remark = res.data.remark;
          } else {
            this.$message({
              type: "info",
              message: res.msg
            });
          }
        })
        .catch((err) => {
          this.saveloading = false;
          this.$message.error("生成失败，请稍后再试！");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 重置展示数据（打开弹窗/切换数据时清空旧内容）
    resetData() {
      this.editForm.inputStoreNo = "";
      this.editForm.supplyKeyId = "";
      this.editForm.remark = "";
    },
    // 生成入库单号
    GenerateInputNumber() {
      GenerateInputNumber({}).then((res) => {
        if (res.code == 1) {
          this.editForm.inputStoreNo = res.data;
          this.$message.success("入库单号获取成功！");
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    // 获取供应商
    getSupplyInfoList() {
      const paramer = {};
      getSupplyInfoList(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.supplyList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取供应商信息失败!");
        });
    },
    // 选择供应商
    handleSelectSupply(val) {
      this.supplyInfo = this.supplyList.find((item) => item.keyId == val);
    },
    // 关闭
    closeDialog() {
      this.$data.editForm = this.$options.data.call(this).editForm;
      this.goodsTypeList = [];
      this.showDialog = false;
    },
    //判断为空则用 -- 替代
    transformEmpty(obj) {
      if (obj == "" || obj == null || obj == undefined) {
        obj = "--";
      }
      return obj;
    },
    //获取商品参数信息
    GetGoodsParamsList() {
      GetGoodsParamsList({})
        .then((res) => {
          if (res.code == 1) {
            this.qiuJingList = res.data.filter((item) => item.type == 1);
            this.zhuJingList = res.data.filter((item) => item.type == 2);
            this.goodsStockQtyList = [];
            for (let i = 0; i < this.qiuJingList.length; i++) {
              let rowItem = [];
              for (let j = 0; j < this.zhuJingList.length; j++) {
                rowItem.push();
              }
              this.goodsStockQtyList.push(rowItem);
            }
          } else {
            this.$message({
              type: "error",
              message: res.msg
            });
          }
        })
        .catch((err) => {
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    // 处理商品类型选择变化
    handleTypeChange(value) {
      if (value && value.length > 0) {
        // 取最后一级的值作为typeKeyId
        this.editForm.typeKeyId = value[value.length - 1];
      } else {
        this.editForm.typeKeyId = "";
      }
      this.search();
    },
    // 获取商品类型数据
    GetAllGoodsTypeTreePageList() {
      GetAllGoodsTypeTreePageList({})
        .then((res) => {
          if (res.code == 1) {
            this.goodsTypeList = res.data;
          } else {
            this.$message({
              type: "info",
              message: res.msg
            });
          }
        })
        .catch((err) => {
          this.$message.error("数据加载失败，请稍后再试！");
        });
    }
  }
};
</script>
<style scoped lang="scss">
.main_bg {
  padding: 10px;
  margin-top: -15px;
}

.item_info {
  border-left: 5px solid #55aaff;
  padding: 5px 10px;
  border-radius: 5px;
  margin-bottom: 15px;
  border-bottom: 2px solid #e9e7e7;
}

.border_Warningcolor {
  border-left: 5px solid #ff9900;
}

.border_Green {
  border-left: 5px solid #00cc66;
}

.item_title {
  display: flex;
  width: 100%;
  font-weight: 700;
  font-size: 1rem;
  margin-bottom: 10px;
  justify-content: space-between;

  .title {
    display: inline-block;
    unicode-bidi: isolate;
  }

  .btnDiv {
    display: block;
    unicode-bidi: isolate;
    word-break: break-all;
  }
}

.tableData {
  width: 100%;
  display: flex;
  margin-top: 20px;
  height: 500px;
  /* 固定容器高度 */
  overflow-y: auto;
  /* 启用垂直滚动 */

  table {
    border: 2px solid #000;
    border-radius: 5px;
    width: auto;
    min-width: 100%;
    background-color: #4ab453;
  }

  table,
  th {
    height: 25px;
    font-family: "楷体";
    font-size: 14px;
    font-weight: 600;
    min-width: 40px;
    border: 1px solid #000;
    position: sticky;
    top: 1px;
    left: 1px;
    background-color: #4ab453;
    z-index: 10;
    /* 确保表头在滚动时覆盖内容 */
    color: white;
  }

  table,
  td {
    border: 1px solid #000;
    padding: 0;
    margin: 0;
    text-align: center;
    border-collapse: collapse;
    font-size: 14px;
    font-family: "宋体";
    font-weight: 600;
    background-color: #4ab453;

    .inputQuantity {
      background-color: #4ab453;
      border: none;
      outline: none;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      text-align: center;
    }
  }

  .qiuJing {
    font-size: 14px;
    font-weight: 600;
    height: 25px;
    line-height: 25px;
    font-family: "楷体";
    width: 40px;
  }
}

/* 固定列样式 */
.fixed-column {
  position: sticky;
  left: 1px;
  z-index: 2;
  background: #4ab453 !important;
  border-right: 2px solid #dee2e6;
}

/* 固定列表头特殊处理 */
thead th.fixed-column {
  z-index: 14;
  left: 1px;
}

.highlight-table {
  border-collapse: collapse;
}

.highlight-table th,
.highlight-table td {
  border: 1px solid #ddd;
}

::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
